module.exports = __webpack_public_path__ + "static/media/306153.4858848d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/306153.pdf
// module id = 880
// module chunks = 0